import React from "react";

import LessonNo from "../../../atoms/ActiveLearning/LessonNo";

import styles from "./Header.module.scss";

interface IHeaderProps {
  no: number;
  label: string;
  title: string;
  read: string;
}

export const Header: React.FC<IHeaderProps> = ({ no, label, title, read }) => {
  return (
    <div className={styles.header}>
      <div className={styles.headerWrapper}>
        <LessonNo no={no} />
        <div className={styles.titleWrapper}>
          <span className={styles.label}>{label}</span>
          <p className={styles.title}>{title}</p>
          <p className={styles.read}>{read}</p>
        </div>
      </div>
    </div>
  );
};

export default Header;
